module.exports = __webpack_public_path__ + "static/media/world-map.d3181121.jpg";